




import { AUTHENTICATION_IS_LOGGED } from '@/modules/authentication/store';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class extends Vue {
  @Getter(AUTHENTICATION_IS_LOGGED)
  private isLogged: boolean;
}
